import {Side} from '../../enums/side';
import {Security} from '../../models/security';

export interface LeveragesForSides {
    buyLeverages: number[];
    sellLeverages: number[];
}

const DEFAULT_SIDE_LEVERAGES: number[] = [];

const CONSTANT_NOT_SELECTABLE_SIDE_LEVERAGES: number[] = [1];

export const CONSTANT_CASH_LEVERAGE = 0;

/**
 * @deprecated
 * [HED-758] Use {@link LeverageService} instead.
 */
export const getLeveragesFromSecurity = (security: Security): LeveragesForSides => {
    let possibleLeverages: LeveragesForSides | unknown;

    if (security.longDescription) {
        try {
            possibleLeverages = JSON.parse(security.longDescription);
        } catch (error) {
            // Do nothing.
        }
    }

    const getLeverageList = (listFieldName: keyof LeveragesForSides): number[] => {
        const list = possibleLeverages
            && (possibleLeverages as LeveragesForSides)[listFieldName];

        if (list) {
            list.sort((value1, value2) => value1 - value2); // ASC
        }

        return list || DEFAULT_SIDE_LEVERAGES;
    };

    return {
        buyLeverages:  getLeverageList('buyLeverages'),
        sellLeverages: getLeverageList('sellLeverages')
    };
};

export const getLeveragesBySide = (leveragesForSides: LeveragesForSides, side: Side): number[] => {
    return side === Side.BUY
        ? leveragesForSides.buyLeverages
        : side === Side.SELL
            ? leveragesForSides.sellLeverages
            : DEFAULT_SIDE_LEVERAGES;
};

/**
 * @deprecated
 * [HED-758] Use {@link LeverageService} instead.
 *
 * Some Exchanges don't support selection of leverage.
 * E.g.: Bitfinex.
 * @param {Security} security
 */
export const isLeverageSelectableForSecurity = (security: Security): boolean => {
    const marginEnabled = !!(security && security.marginEnabled);
    const leverages = marginEnabled && getLeveragesFromSecurity(security);

    return isLeverageSelectable(leverages);
};

export const isLeverageSelectable = (leverages: LeveragesForSides): boolean =>
    leverages && (
        isSideLeverageSelectable(leverages.buyLeverages)
        || isSideLeverageSelectable(leverages.sellLeverages)
    );

export const isSideLeverageSelectable = (sideLeverages: number[]): boolean =>
    sideLeverages && sideLeverages !== DEFAULT_SIDE_LEVERAGES;

export const getDefaultLeveragesForSides = (): LeveragesForSides => ({
    buyLeverages: DEFAULT_SIDE_LEVERAGES,
    sellLeverages: DEFAULT_SIDE_LEVERAGES
});

export const getConstantNotSelectableLeveragesForSides = (): LeveragesForSides => ({
    buyLeverages: CONSTANT_NOT_SELECTABLE_SIDE_LEVERAGES,
    sellLeverages: CONSTANT_NOT_SELECTABLE_SIDE_LEVERAGES
});
